import { UAE_PATHS } from "./UaeMapPaths";

const CITIES = [
  { name: "Dubai",          count: "2,400+", top: "44%", left: "70%" },
  { name: "Abu Dhabi",      count: "1,100+", top: "57%", left: "40%" },
  { name: "Sharjah",        count: "640+",   top: "40%", left: "75%" },
  { name: "Ajman",          count: "290+",   top: "35%", left: "78%" },
  { name: "Ras Al Khaimah", count: "180+",   top: "25%", left: "86%" },
  { name: "Fujairah",       count: "160+",   top: "40%", left: "92%" },
];

const EMIRATES = [
  "Dubai",
  "Abu Dhabi",
  "Sharjah",
  "Ajman",
  "Ras Al Khaimah",
  "Fujairah",
];

export function LandingMapSection() {
  return (
    <section id="cities" className="lp-py-16 lp-px-6 lp-relative lp-overflow-hidden">
      <div className="lp-max-6xl lp-mx-auto">
        
        <div className="lp-grid lp-grid-cols-1 md-cols-2 lp-gap-12 lp-items-center">
          
          {/* Left Column: Description & supported Emirates */}
          <div>
            <p
              className="lp-text-blue lp-text-xs lp-uppercase lp-tracking-wide lp-mb-3"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              UAE Focus
            </p>
            <h2
              className="lp-text-dark lp-mb-6"
              style={{
                fontFamily: "'Fraunces', serif",
                fontWeight: 600,
                letterSpacing: "-0.025em",
                fontSize: "clamp(2rem, 4.5vw, 3.2rem)",
                lineHeight: 1.1,
              }}
            >
              Built for the UAE Hospitality Scene
            </h2>
            
            <div
              className="lp-text-muted lp-leading-relaxed lp-mb-8 lp-flex lp-flex-col lp-gap-4"
              style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300, fontSize: "1.05rem" }}
            >
              <p>
                HubScroll is designed specifically for the UAE market and understands how people discover venues in cities like Dubai and Abu Dhabi.
              </p>
              <p>
                The platform connects hospitality businesses with people actively searching for places to visit.
              </p>
            </div>

            <div className="lp-mb-4">
              <span className="lp-text-dark lp-text-sm lp-font-medium lp-uppercase lp-tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>
                HubScroll supports venues across:
              </span>
            </div>

            {/* List of Emirates with blue checks */}
            <div className="lp-grid lp-grid-cols-2 lp-gap-4">
              {EMIRATES.map((emirate, idx) => (
                <div key={idx} className="lp-flex lp-items-center lp-gap-3">
                  <span className="lp-text-blue lp-font-medium">✓</span>
                  <span className="lp-text-dark lp-text-base" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400 }}>
                    {emirate}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column: UAE Interactive Map */}
          <div className="lp-relative lp-w-full lp-mx-auto" style={{ maxWidth: 580 }}>
            <svg
              viewBox="0 0 760 613"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="lp-w-full"
            >
              {UAE_PATHS.map((path) => (
                <path
                  key={path.id}
                  id={path.id}
                  aria-label={path.label}
                  className="lp-map-path"
                  d={path.d}
                />
              ))}
            </svg>

            {/* City pins */}
            {CITIES.map((city) => (
              <div
                key={city.name}
                className="lp-absolute lp-group"
                style={{ top: city.top, left: city.left, transform: "translate(-50%, -50%)" }}
              >
                <div className="lp-relative lp-flex lp-items-center lp-justify-center">
                  <div className="lp-w-25 lp-h-25 lp-r-full lp-bg-blue lp-z-10 lp-relative" />
                  <div className="lp-absolute lp-w-25 lp-h-25 lp-r-full lp-bg-blue lp-ping lp-op-40" />
                </div>
                {/* Glassmorphic City Pins Hover Badge */}
                <div
                  className="lp-absolute lp-tx-neg-half lp-top-5 lp-nowrap lp-text-center lp-op-0 lp-gh-op-100 lp-transition-op lp-glass-card lp-border lp-r-lg lp-px-3 lp-py-2 lp-z-20"
                  style={{ left: "50%", boxShadow: "0 4px 20px rgba(0,0,0,0.5)" }}
                >
                  <div className="lp-text-dark lp-text-xs lp-font-medium">{city.name}</div>
                  <div className="lp-text-blue lp-text-xs lp-mt-05">{city.count} venues</div>
                </div>
              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
}
